import React, {useCallback, useEffect, useRef, useState} from "react";
import styled from "@emotion/styled/macro";
import HomeCard, {IHomeCardHomeProps} from "../../layout/HomeCard";
import BigScreenCommunity3D from "../../../unreal/BigScreenCommunity3D";
import {useNavigate} from "react-router-dom";
import {ICamera, IModel, ISlsOrd} from "../../../kova/slsordClient";
import DropdownFilter from "../homesiteSelection/DropdownFilter";
import {ReactComponent as BedIcon} from "../../../img/bed-icon.svg";
import {ReactComponent as BathIcon} from "../../../img/bath-icon.svg";
import {ReactComponent as SqftIcon} from "../../../img/sqft-icon.svg";
import useUnrealUri from "../../../unreal/UnrealContentProvider";
import {useVscContext} from "../../content/VscReactContext";
import { CameraCards } from "./CameraCards";
import {useModels} from "../../../data/modelSource";
import {useQueryState} from "use-location-state";
import {useConfig} from "../../../config";
import {IViewCamera, IViewItemConfig} from "../vscSiteSpecific/SiteSpecific";
import {VscVideoPlayer} from "../../video/VscVideoPlayer";
import {BigScreenCommunityMap} from "../communitymap/BigScreenCommunityMap";



const FindYourHomeDiv = styled.div`
    display: flex;
  flex-direction:row;
  
  min-height:0;
  
  .cameras {
    padding:16px 32px 16px 32px;
    flex: 1 1;
    width: 45%;
    //height: 100%;
    
    overflow-x:hidden;
    overflow-y:scroll;
  }
  
  .homes {
    //flex: 0 0 597px;
    width: 55%;
    display:flex;
    flex-direction:column;
    
  
  }
  .hometabs {
    display:flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
  
    .active {
      background: var(--primary-color);
      color: var(--content-background);
    }
  }
  
  .tab {
    flex: 1 1 1px;
    text-align: center;
    border: 1px solid black;
    
    padding:16px;

  }

  .filters {
    margin-left: 20px;
    > * { display: inline; }
    span {
      margin-left:20px;
    }
  }
  .cards {
    background-color: var(--content-background);
 
    overflow-y:scroll;
    display:flex;
    flex-direction:row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-content: flex-start;
    width: 100%;
    height: 100%;
    > * {
      flex: 0 0 255px;

    }
  }
`


export const HomesiteHeader = styled.header`
    align-items: center;
    background: var(--content-background);
    display: flex;
    justify-content: space-between;
    padding: 16px 32px;

    & h3 {
      font-size: 1.125rem;
      font-weight: 500;
      margin: 0 0 0.5rem 0;
    }

    & h4 {
      font-size: 0.875rem;
      font-weight: 500;
    }

    & > span:last-of-type {
        display: flex;

    }

    & > span:last-of-type > div {
      margin-right: 24px;
    }
    & > span:last-of-type > div:last-child {
      margin-right: 0;
    }
`
function distinct(value: string, index: number, self:string[]) {
    return self.indexOf(value) === index;
}

function isBathMatch(value: Set<string>, homesite: ISlsOrd) {
    if (value.has('all')) {
        return true;
    } else {
        return value.has(homesite.baths + ' Baths');
    }
}

function isBedMatch(value: Set<string>, homesite: ISlsOrd) {
    if (value.has('all')) {
        return true;
    } else {
        return value.has(homesite.bedrooms + ' Beds');
    }
}

function isSqftMatch(values: Set<string>, homesite: ISlsOrd) {
    if (values.has('all')) {
        return true;
    } else {
        for (const value of Array.from(values.values())) {
            const bottomBound = Number(value.split('-')[0]) <= Number(homesite.sqf);
            const topBound = Number(value.split('-')[1]) >= Number(homesite.sqf);

            if (bottomBound && topBound) return true;
        }
        return false;
    }
}


export interface IFilterListProps {
    filters: { key: string, name: string}[];
    onRemoveFilter: (key:string) => void;
}
function getHomePropsFromModel(model: IModel): IHomeCardHomeProps {
    return {
        baths: model.baths,

        bedrooms: model.bedrooms,
        marketingName: model.marketingName,
        price: model.marketingPrice,
        sqf: model.sqf
    }
}
const FilterList: React.FC<IFilterListProps> = (props) => {

    const { filters, onRemoveFilter } = props;
    return <div>
        {filters.map(filter => <span onClick={() => onRemoveFilter(filter.key)}>
            {filter.name} X
            </span>)
        }
    </div>
}
const ModelCards: React.FC<{models: IModel[]}> = (props) => {
    const { models } = props;

    const { server } = useConfig();

    const vscContext = useVscContext();

    const navigate = useNavigate();
    return <>{models.map(model => <HomeCard onViewDetails={() => navigate(vscContext.getNavigateContentUri("plan?id=") + model.id)}
                                            onClick={() => 0} home={getHomePropsFromModel(model)} imageUrl={vscContext.getHtmlControllerUri(model.images.elevation)}
                                            />) }
        </>
}
const FindYourHome: React.FC<{
    slsOrds: ISlsOrd[],
    viewItems: IViewItemConfig[],
    favorites: Set<number>,
    features: string[],
    updateFavorites: (favorites:Set<number>) => void}> = (props) => {

    const {slsOrds, favorites, updateFavorites, viewItems, features} = props;

    const models = useModels();

    const [viewItem, setViewItem] = useState<string>(viewItems.length > 0 ? viewItems[0].name : "");
    const [baths, setBaths] = useState<Set<string>>(new Set<string>(["all"]));
    const [beds, setBeds] = useState<Set<string>>(new Set<string>(["all"]));
    const [sqft, setSqft] = useState<Set<string>>(new Set<string>(["all"]));

    const [mode, setMode] = useQueryState<"market" | "floorplans">('mode',
        features.includes("markethomes") ? "market" : "floorplans");
    const vscContext = useVscContext();



    function applyFilters(value: ISlsOrd) {
        return isBathMatch(baths, value) &&
            isBedMatch(beds, value) &&
            isSqftMatch(sqft, value);
    }

    const navigate = useNavigate();



    function setFavorite(slsOrdId: number, isFavorite: boolean) {
        const updFavorites = new Set(favorites);
        if (isFavorite) {
            updFavorites.add(slsOrdId);
        } else {
            updFavorites.delete(slsOrdId);
        }
        updateFavorites(updFavorites);
    }


    function getChangeFunc(set: Set<string>, setSet: (set: Set<string>) => void) {


        const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
            //  debugger;
            const val = ev.currentTarget.value;
            const newSet = new Set(set);
            if (newSet.has(val)) {
                newSet.delete(val);
            } else {
                if (val === "all") { // Check all, uncheck everything else
                    setSet(new Set<string>(["all"]));
                    return;
                } else {
                    // Something else is checked, uncheck all
                    newSet.delete("all");
                }
                newSet.add(val);
            }
            setSet(newSet);
        }
        return onChange;
    }

    const onBedChange = getChangeFunc(beds, setBeds);
    const onBathChange = getChangeFunc(baths, setBaths);
    const onSqftChange = getChangeFunc(sqft, setSqft);
    const activeFilters: { name: string, key: string }[] = [];
    if (!beds.has("all")) {
        activeFilters.push({name: "Beds", key: "beds"});
    }
    if (!baths.has("all")) {
        activeFilters.push({name: "Baths", key: "baths"});
    }
    if (!sqft.has("all")) {
        activeFilters.push({name: "Sq Ft", key: "sqft"});
    }
    const onRemoveFilter = (filterKey: string) => {
        if (filterKey === "beds") {
            setBeds(new Set(["all"]));
        }
        if (filterKey === "baths") {
            setBaths(new Set(["all"]));
        }
        if (filterKey === "sqft") {
            setSqft(new Set(["all"]));
        }


    }

    const items = slsOrds.map(so => ({slsOrd: so, levelGroup: 'All', showParking: false}));

    const vi = viewItems.find(v => v.name === viewItem) ?? viewItems[0];
console.log(vi);

    return <>
        { vi.type === "camera" && <BigScreenCommunity3D camera={vi.camera} items={items}/> }
        { vi.type === "video" && <VscVideoPlayer videoName={vi.video} videoTitle={vi.name} looping={vi.looping ?? false} /> }
        { vi.type === "map" && <BigScreenCommunityMap viewBox={vi.viewBox} /> }

        <HomesiteHeader>
                    <span>
                    </span>
            <span>
                        <DropdownFilter
                            handleChange={onBedChange}
                            icon={BedIcon}
                            inputs={['all', '2 Beds', '3 Beds']}
                            label="Beds"
                            value={Array.from(beds)}
                        />
                        <DropdownFilter
                            handleChange={onBathChange}
                            icon={BathIcon}
                            inputs={['all', '1 Bath', '1.5 Baths', '2 Baths', '2.5 Baths']}
                            label="Baths"
                            value={Array.from(baths)}
                        />
                        <DropdownFilter
                            handleChange={onSqftChange}
                            icon={SqftIcon}
                            inputs={['all', '0 - 1000', '1000 - 1250', '1250 - 1500']}
                            label="SQ FT"
                            value={Array.from(sqft)}
                        />
                    </span>
        </HomesiteHeader>
        <FindYourHomeDiv>
            <div className={"cameras"}>
                <CameraCards cameras={viewItems} activeCamera={viewItem}
                             onSetCamera={(camera: IViewItemConfig) => setViewItem(camera.name)}/>

            </div>
            <div className={"homes"}>
                {activeFilters.length > 0 && <div className={'filters'}><h4>Filters:</h4>
                    <FilterList filters={activeFilters} onRemoveFilter={onRemoveFilter}/>
                </div>}
                <div className={"hometabs"}>
                    { features.includes("markethomes") &&
                    <div className={"tab " + (mode === "market" ? "active" : "")} onClick={() => setMode("market")}>
                        Available Homes
                    </div>
                    }
                    { features.includes("floorplans") &&
                    <div className={"tab " + (mode === "market" ? "" : "active")} onClick={() => setMode("floorplans")}>
                        Floorplans
                    </div>
                    }
                </div>
                <div className={"cards"}>
                    {mode === "market" && slsOrds.filter(slsOrd => applyFilters(slsOrd))
                        .filter(slsOrd => !slsOrd.isSold)
                        .map(home =>
                            <HomeCard
                                onViewDetails={() => navigate(vscContext.getNavigateContentUri("markethome?id=") + home.id)}

                                home={home}
                                imageUrl={vscContext.getHtmlControllerUri(home.images["elevation"])}
                                />
                        )}
                    {mode === "floorplans" && models !== null && <ModelCards models={models}/>}
                </div>


            </div>
        </FindYourHomeDiv>
    </>
}

export default FindYourHome;